class FilterGroup {
	constructor(list, title, name, controller) {
		this.list = list;
		this.name = name;
		this.controller = controller;
		this.filters = [];

		this.elem = div('m-2', [
			htm('h5', null, title),
			this.filtersElem = div()
		]);

		controller.filterGroup = this;

		onEv(document, 'filtersChanged', this.update.bind(this));
		this.update();
	}

	update() {
		this.filters = [];
		this.filtersElem.innerHTML = '';
		for (let f of this.controller.filters) {
			let filter = new Filter(this, f[0], f[1]);
			if (this.list.saved[this.name]) filter.checked = this.list.saved[this.name].split(',').map(s => parseInt(s)).indexOf(f[0]) !== -1;
			this.filters.push(filter);
			this.filtersElem.append(filter.row);
		}
	}
	
	clear() {
		this.filters.forEach(f => f.clear());
	}

	get toString() {
		return this.filters.map(f => f.checked ? `&${this.name}[]=${f.id}` : '').join('');
	}
}

class Status {
	constructor() {
		this.filters = [
			[0, 'Active'],
			[1, 'Complete'],
			[2, 'Exchanged'],
		]
	}
}